import { END_POINTS } from '../constants/urls';
import { CommonBody, FaqRes, CMS, GetFaqResponse } from '../types/General';
import { User } from '../types/User';
import emptySplitApi from '../utils/rtk';

interface CommonResponseType {
  statusCode: number;
  data?: User;
  message: string;
}

interface CommonResponse {
  statusCode: number;
  message?: string;
  data?: any;
}



export interface GetSettingResponse {
  inspectionFee: number;
  postingFee: number;
  _id: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  id: string;
}

export const SettingsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getSettings: builder.query<CommonResponse & { data: any }, {}>({
      query: () => ({
        url: END_POINTS.addSetting,
        method: 'GET',
      }),
    }),
    updateSetting: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateSetting}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    addSetting: builder.mutation<CommonResponseType & { data: any }, { body: any }>({
      query: ({ body }) => ({
        url: END_POINTS.addSetting,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
useAddSettingMutation,
useLazyGetSettingsQuery,
useUpdateSettingMutation
} = SettingsApi;
